import { finView } from '../../../lib/finView.cls';
var Const = /** @class */ (function () {
    function Const() {
    }
    // log tag
    Const.TAG = 'finView';
    /*************************************************
    ////// store method hooks from here //////
    **************************************************/
    // CONTACT US
    Const.RUN_CONTACT_US = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_CONTACT_US';
    // ALL COUNTRIES
    Const.GET_USER_WATCH_LISTING = 'GET_USER_WATCH_LISTING';
    Const.SET_USER_WATCH_LISTING = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/SET_USER_WATCH_LISTING';
    Const.RUN_USER_WATCH_LISTING = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_USER_WATCH_LISTING';
    // CATEGORIES_LISTING
    Const.GET_CATEGORIES_LISTING = 'GET_CATEGORIES_LISTING';
    Const.SET_CATEGORIES_LISTING = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/SET_CATEGORIES_LISTING';
    Const.RUN_CATEGORIES_LISTING = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_CATEGORIES_LISTING';
    // ARTICELS_LISTING
    Const.GET_ARTICELS_LISTING = 'GET_ARTICELS_LISTING';
    Const.SET_ARTICELS_LISTING = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/SET_ARTICELS_LISTING';
    Const.RUN_ARTICELS_LISTING = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_ARTICELS_LISTING';
    // USER_REVIEW
    Const.RUN_USER_REVIEW = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_USER_REVIEW';
    Const.RUN_GET_USER_ID_FROM_CLIENTCODE = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_GET_USER_ID_FROM_CLIENTCODE';
    //compaints
    Const.GET_COMPLAINTS_DATA = 'GET_COMPLAINTS_DATA';
    Const.SET_COMPLAINTS_DATA = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/SET_COMPLAINTS_DATA';
    Const.RUN_GET_COMPLAINTS_DATA = finView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_GET_COMPLAINTS_DATA';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/finView/provider/candle-history/lib/const.cls.ts
// module id = null
// module chunks = 